import { makeStyles } from '@material-ui/core'

export const styles = makeStyles((theme) => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '552px',
  },
  root2: {
    width: '900px',
    [theme.breakpoints.only('md')]: {
      width: '43rem',
    },
    [theme.breakpoints.only('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
  },
  cardSelectImg: {
    height: '240px',
    padding: '1em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  cardContentSelectImg: {},
}))
